module.exports = __webpack_public_path__ + "fonts/iconfont.48faef55.ttf";